module.exports = __webpack_public_path__ + "img/together.31a46127.jpg";